import { Swiper } from "swiper";
import { Navigation, Pagination, A11y } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/a11y";

// Add to window
window.Swiper = Swiper;
window.Swiper_Pagination = Pagination;
window.Swiper_Navigation = Navigation;
window.Swiper_A11y = A11y;
